
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { UserRightsMixin } from '@/mixins/UserRights';
import SettingsTopBar from '@/modules/CMS/layout/SettingsTopBar.vue';
import NotAllowedComponent from '@/modules/CMS/layout/NotAllowedComponent.vue';
import { RouteNames } from '@/enums/routes/RouteNames';
import DevCommandAPI from '@/services/DevCommandAPI';

@Component({
    name: 'ServerCommands',
    components: {
        SettingsTopBar,
        NotAllowedComponent,
    },
})
export default class ServerCommands extends mixins<UserRightsMixin>(UserRightsMixin) {
    private backRoute: RouteNames = RouteNames.settings;
    private command: string = '';
    private output: string | null = null;
    private exitCode: number | null = null;
    private isLoading: boolean = false;

    private get userHasRights() {
        return this.canSeeDevTools;
    }

    private async runCommand() {
        if (!this.command.trim()) {
            return;
        }

        this.isLoading = true;
        this.output = null;
        this.exitCode = null;

        try {
            const response = await DevCommandAPI.run(this.command.trim());
            this.output = response.data.output;
            this.exitCode = response.data.exitCode;
        } catch (error) {
            this.$notification.error({
                message: this.$t('Error running command') as string,
                description: '',
            });
        } finally {
            this.isLoading = false;
        }
    }
}
